import JobCollection from '../../models/JobCollection'
import PaginatedResults from '../../helpers/PaginatedResults'

export default {
    channel: null,
    columns: [],
    labels: [],
    jobs: new JobCollection(),
    members: [],
    archive: new PaginatedResults(),
    currentChannelMember: null,
    filters: {
        labels: [],
        users: []
    }
}
